module.exports = __webpack_public_path__ + "static/media/Android_trd.a3c99c64.jpg";